/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Tab_Resume_PerformanceInputs */

const en_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume Performance`)
};

const de_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf-Leistung`)
};

const fr_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance des CV`)
};

const es_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento del currículum`)
};

const it_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestazioni curriculum`)
};

const nl_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-prestaties`)
};

const pl_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skuteczność CV`)
};

const fi_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelon suorituskyky`)
};

const da_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-performance`)
};

const sv_analytics_tab_resume_performance = /** @type {(inputs: Analytics_Tab_Resume_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-prestanda`)
};

/**
* | output |
* | --- |
* | "Resume Performance" |
*
* @param {Analytics_Tab_Resume_PerformanceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_tab_resume_performance = /** @type {((inputs?: Analytics_Tab_Resume_PerformanceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Tab_Resume_PerformanceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_tab_resume_performance(inputs)
	if (locale === "fr") return fr_analytics_tab_resume_performance(inputs)
	if (locale === "es") return es_analytics_tab_resume_performance(inputs)
	if (locale === "it") return it_analytics_tab_resume_performance(inputs)
	if (locale === "nl") return nl_analytics_tab_resume_performance(inputs)
	if (locale === "pl") return pl_analytics_tab_resume_performance(inputs)
	if (locale === "fi") return fi_analytics_tab_resume_performance(inputs)
	if (locale === "da") return da_analytics_tab_resume_performance(inputs)
	if (locale === "sv") return sv_analytics_tab_resume_performance(inputs)
	return en_analytics_tab_resume_performance(inputs)
});